<template>
  <div class="touristBatchImport">
    <ul class="ticket-list">
      <li :ref="`DOM${item.metaTicketInfo.productId}`" v-for="(item, index) in controllerNumber" :key="item.metaTicketInfo.productId" v-if="item.orderItemAttr.length">
        <div class="title">
          <strong>{{ item.displayName }}</strong>
          <span>最多可导入{{ item.orderItemAttr.length }}人</span>
        </div>
        <div class="text">
          <textarea v-model.trim="inputData[index]" :placeholder="defaultContent"></textarea>
        </div>
      </li>
    </ul>
    <div class="tabber">
      <button class="cancel" @click="clickback">取消</button>
      <button class="determine" @click="clickSubmit">确定</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "touristBatchImport",
  data(){
    return {
      defaultContent: '录入格式：“证件号  姓名”为一行\n示例：110101*******1234  张某',
      controllerNumber: [],
      inputData: [],
      selectDate: ''
    }
  },
  created(){
    this.selectDate = this.$route.query.selectDate
    this.initialization();
  },
  methods: {
    initialization(){
      const controllerNumber = JSON.parse(window.sessionStorage.getItem('controllerNumber')) || false;
      controllerNumber.forEach((item, index) => {
        this.inputData.push('');
        item.orderItemAttr.forEach(v => {
          if(v.traverllerCerNo){
            this.inputData[index] += `${v.traverllerCerNo} ${v.traverllerName}\n`;
          }
        });
      });
      this.controllerNumber = controllerNumber;
    },
    clickback(){
      this.$router.go(-1);
    },
    clickSubmit(){
      if(this.inputData.every(v => !v.length))return this.$toast('至少输入一个游客信息');
      const IdWarning = [];
      const ageWarning = [];
      const formatWarning = [];
      const coincidenceWarning = [];
      const nameLengthWarning = [];
      const reg = /^\s*?([\s\S]+)\s?([\s\S]+)\s*?$/m;
      this.controllerNumber.forEach((item, index) => {
        const { metaTicketInfo } = item;
        if(!this.inputData[index]){
          item.orderItemAttr.forEach(v => {
            v.traverllerName = '';
            v.traverllerPhone = '';
            v.traverllerEmail = '';
            v.traverllerCerType =  metaTicketInfo.needTravellerIDCard === "true" ? 'id_card' : 'passport';
            v.traverllerCerNo = '';
          });
          return;
        };
        let originList = this.inputData[index].match(reg)[0].trim().split('\n');
        const IdList = [];
        const newList = originList.map((v, i) => {
          const fixArray = v.trim().split(/[\s\n]/).filter(v => v);
          if(fixArray.length < 2){
            formatWarning.push(item.displayName + '身份证格式错误');
            return;
          };
          let IDNumber = fixArray[0];

          if(IdList.includes(IDNumber)){
            coincidenceWarning.push(`${IDNumber}证件号重复`)
          }
          IdList.push(IDNumber);
          const name = fixArray[1];
          if(metaTicketInfo.needTravellerIDCard === "true"){
            IDNumber = IDNumber.toUpperCase();
            const { travellerMinAge, travellerMaxAge } = metaTicketInfo.saleAgeInfos[0];
            if(!this.$reg.checkIDCard(IDNumber)){
              IdWarning.push(`${IDNumber}证件号格式错误`);
              return;
            };
            if(name.length >= 240){
              nameLengthWarning.push(`${IDNumber}姓名长度最大为240位`);
            }
            const age = this.$reg.checkAge(IDNumber,this.selectDate);
            // 优惠票团队录入加25岁校验
            if(metaTicketInfo.saleType === 'discount' && age > travellerMaxAge) {
              ageWarning.push(`${IDNumber}${name}不符合自动识别年龄，请持优惠证件到人工窗口购票`)
              return;
            }
            if(!(age >= travellerMinAge && age <= travellerMaxAge)){
              ageWarning.push(`${IDNumber}${name}年龄不符合购买该票种`)
              return;
            };
          }else if(metaTicketInfo.needTravellerPassport === "true"){
            if(IDNumber.length > process.env.VUE_APP_PASSPORT_MAX_LENGTH){
              IdWarning.push(`${IDNumber}证件号最大长度为${process.env.VUE_APP_PASSPORT_MAX_LENGTH}`);
            }
          }else if(metaTicketInfo.needTravellerHKMTPassport === "true"){
            if(IDNumber.length > process.env.VUE_APP_HKMO_IDCARD_MAX_LENGTH){
              IdWarning.push(`${IDNumber}证件号最大长度为${process.env.VUE_APP_HKMO_IDCARD_MAX_LENGTH}`);
            }
          }else if(metaTicketInfo.needTravellerPRC === "true"){
            if(IDNumber.length > process.env.VUE_APP_PRC_MAX_LENGTH){
              IdWarning.push(`${IDNumber}证件号最大长度为${process.env.VUE_APP_PRC_MAX_LENGTH}`);
            }
          };
          return {
            traverllerName: name,
            traverllerPhone: '',
            traverllerEmail: '',
            traverllerCerType: item.orderItemAttr[i] && item.orderItemAttr[i].traverllerCerType,
            traverllerCerNo: IDNumber,
          };
        });
        item.orderItemAttr.forEach((v, i) => {
          if(newList[i]){
            Object.assign(v, newList[i]);
          }else{
            v.traverllerName = '';
            v.traverllerPhone = '';
            v.traverllerEmail = '';
            v.traverllerCerNo = '';
          };
        });
      });
      if(IdWarning.length){
        return this.$toast({
          textList: IdWarning
        });
      };
      if(ageWarning.length){
        return this.$toast({
          textList: ageWarning
        });
      };
      if(coincidenceWarning.length){
        return this.$toast({
          textList: coincidenceWarning
        });
      };
      if(formatWarning.length){
        return this.$toast('请在证件号和姓名中间添加空格符');
      };
      if(nameLengthWarning.length){
        return this.$toast('姓名长度最大为240位');
      };
      window.sessionStorage.setItem('controllerNumber', JSON.stringify(this.controllerNumber))
      if(!IdWarning.length && !ageWarning.length){
        this.clickback();
      };
    },
  }
};
</script>

<style scoped lang='less'>
.touristBatchImport{
  min-height: 100vh;
  padding-bottom: 2.333333rem;
  position: relative;
  .ticket-list{
    padding: .266667rem;
    & > li{
      height: 6.24rem;
      background: #FFFFFF;
      border-radius: .213333rem;
      margin-bottom: .266667rem;
      &:last-child{
        margin-bottom: 0;
      }
      .title{
        padding: .266667rem .533333rem .2rem;
        display: flex;
        align-items: center;
        strong{
          font-size: .48rem;
          font-weight: bold;
          color: #000000;
          line-height: .666667rem;
        }
        span{
          font-size: .32rem;
          color: #333333;
          line-height: .44rem;
          margin-left: .226667rem;
        }
      };
      .text{
        padding: 0 .333333rem .333333rem;
        textarea{
          width: 100%;
          height: 4.866667rem;
          border-radius: .213333rem;
          border: 1px solid #979797;
          font-size: .32rem;
          padding: .266667rem;
          line-height: .48rem;
          &::placeholder{
            line-height: .48rem;
            color: #999;
          }
        }
      }
    }
  };
  .tabber{
    padding: .506667rem .4rem .6rem;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    button{
      width: 4.4rem;
      height: 1.2rem;
      border-radius: .6rem;
      border: 1px solid #333333;
      font-size: .4rem;
      color: #333333;
      line-height: .56rem;
    }
  }
}
</style>
